var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralFeatureThumbsdownOff = function SvgGeneralFeatureThumbsdownOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M18.883 2.022h.637a2.264 2.264 0 0 1 2.263 2.264v9.032h-2.9zM13.126 22.5a2.26 2.26 0 0 1-2.26-2.225l-.004-3.634a2.265 2.265 0 0 0-2.265-2.264h-5.09A1.71 1.71 0 0 1 1.8 12.668c0-.893.694-1.631 1.57-1.702a1.704 1.704 0 0 1 .758-3.154 1.7 1.7 0 0 1-.82-1.452c0-.894.697-1.632 1.572-1.702a1.7 1.7 0 0 1-.816-1.451c0-.94.768-1.708 1.707-1.708h4.576q.112 0 .222.014l.875.021 1.264.045.802.036 1.488.084 1.867.134 2.017.188.014 11.297-.625.88-.34.457-.335.418c-.29.347-.63.707-1.145 1.223-.854.854-1.024 1.843-1.054 3.256l-.006.683a2.264 2.264 0 0 1-2.046 2.254z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralFeatureThumbsdownOff;